import { getApiBaseUrl as getConfiguredApiBaseUrl, getApiKey as getConfiguredApiKey, toMockErrorResponse, toMockResponse } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
const getApiBase = () => getConfiguredApiBaseUrl()
const getApiKey = () => getConfiguredApiKey()

Mock.onGet('/api/billing/current').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/current/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('billing current error', e)
        return [500, { message: 'Ошибка получения текущего тарифа' }]
    }
})

Mock.onGet('/api/billing/wallet').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/wallet/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('billing wallet get error', e)
        return [500, { message: 'Ошибка получения баланса' }]
    }
})

Mock.onPost('/api/billing/plan/buy').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/plan/buy/`, data || {})
        return toMockResponse(response)
    } catch (e) {
        console.error('billing plan buy error', e)
        return toMockErrorResponse(e, 'Ошибка покупки тарифа')
    }
})

Mock.onPost('/api/billing/multibrand/preview').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        return toMockResponse(await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/multibrand/preview/`, data || {}))
    } catch (e) {
        return toMockErrorResponse(e, 'Ошибка проверки лимита брендов')
    }
})

Mock.onPost('/api/billing/multibrand/selection/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        return toMockResponse(await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/multibrand/selection/save/`, data || {}))
    } catch (e) {
        return toMockErrorResponse(e, 'Ошибка сохранения выбора брендов')
    }
})

Mock.onGet('/api/billing/usage').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/usage/current/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('billing usage error', e)
        return [500, { message: 'Ошибка получения лимитов тарифа' }]
    }
})

Mock.onGet('/api/billing/plans/public').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/plans/public/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('billing public plans error', e)
        return [500, { message: 'Ошибка получения публичных тарифов' }]
    }
})

Mock.onPost('/api/billing/orders-addon/list').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/orders-addon/list/get/`, data || {})
        return [200, response?.data || {}]
    } catch (e) {
        console.error('billing orders addon list error', e)
        return [500, { message: 'Ошибка получения докупок заказов' }]
    }
})

Mock.onGet('/api/billing/orders-addon/packages').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/orders-addon/packages/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('billing orders addon packages error', e)
        return [500, { message: 'Ошибка получения пакетов докупки' }]
    }
})

Mock.onPost('/api/billing/orders-addon/buy').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=billing/orders-addon/buy/`, data || {})
        return [200, response?.data || {}]
    } catch (e) {
        console.error('billing orders addon buy error', e)
        return [500, { message: 'Ошибка докупки пакета заказов' }]
    }
})
